import { formatNumber } from "@SeemplicityDev/shared";
import React from "react";
import { useAnimateInView } from "./useAnimateInView";
import BackgroundImage from "../Assets/TopQueuesPage/bg.png";
import FirstPlace from "../Assets/TopQueuesPage/first-place.svg";
import SecondPlace from "../Assets/TopQueuesPage/second-place.svg";
import ThirdPlace from "../Assets/TopQueuesPage/third-place.svg";
import BackCard from "../Assets/TopQueuesPage/card-back.svg";

const getImageForPlace = (place: number): string => {
  switch (place) {
    case 1:
      return FirstPlace;
    case 2:
      return SecondPlace;
    case 3:
      return ThirdPlace;
    default:
      return "";
  }
};

interface TopQueuesPageProps {
  data?: {
    opened_tickets_count: number;
    opened_findings_count: number;
    closed_tickets_count: number;
    closed_findings_count: number;
    queues: {
      name: string;
      closed_findings_count: number;
      opened_tickets_count: number;
      closed_tickets_count: number;
      avg_ticket_time: number;
    }[];
  };
  hasAssignees?: boolean;
}

const TopQueuesPage: React.FC<TopQueuesPageProps> = ({
  data,
  hasAssignees,
}) => {
  const { ref, animateClassNames } = useAnimateInView();
  const {
    opened_tickets_count,
    opened_findings_count,
    closed_tickets_count,
    closed_findings_count,
    queues,
  } = data || {};
  return (
    <div className={`eoy-page top-queues-page ${animateClassNames}`} ref={ref}>
      <img src={BackgroundImage} alt="Background" className="bg-image" />
      {!hasAssignees ? (
        <>
          <h2 className="page-title">
            Closed {formatNumber(closed_tickets_count)} Tickets for{" "}
            {formatNumber(closed_findings_count)} Findings*
          </h2>
          <h3 className="page-subtitle">
            You opened {formatNumber(opened_tickets_count)} tickets for{" "}
            {formatNumber(opened_findings_count)} findings{" "}
          </h3>
        </>
      ) : (
        <h2 className="page-title">Top 3 Automations</h2>
      )}
      <div className="queues-container">
        {queues?.map((queue, index) => {
          return (
            <div
              className={`queue-item queue-item-${index + 1}`}
              key={queue.name}
            >
              <div className="queue-item-inner">
                <div className="queue-card-front">
                  <img
                    src={getImageForPlace(index + 1)}
                    alt={`Place ${index + 1}`}
                    className="queue-item-image"
                  />
                  <span className="queue-item-name-wrapper">
                    <span className="queue-item-name">{queue.name}</span>
                  </span>
                  <div className="closed-findings">
                    Closed Findings:{" "}
                    <span>{formatNumber(queue.closed_findings_count)}</span>
                  </div>
                  <div className="ticket-counts">
                    <div className="ticket-count-item opened-tickets">
                      Opened Tickets:{" "}
                      <span>{formatNumber(queue.opened_tickets_count)}</span>
                    </div>
                    <div className="ticket-count-item closed-tickets">
                      Closed Tickets:{" "}
                      <span>{formatNumber(queue.closed_tickets_count)}</span>
                    </div>
                  </div>
                  <div className="avg-ticket-time">
                    Ticket Avg Age:{" "}
                    <span>{formatNumber(queue.avg_ticket_time)} days</span>
                  </div>
                </div>
                <div
                  className="queue-card-back"
                  style={{ backgroundImage: `url(${BackCard})` }}
                >
                  {/* <img
                    src={BackCard}
                    alt="Back Card"
                    className="back-card-image"
                  /> */}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      {!hasAssignees && (
        <div className="disclaimer">*Some tickets were opened before 2025</div>
      )}
    </div>
  );
};

export default TopQueuesPage;
